const makeInitialState = () => {
  return {
    name: '',
    denomination: '',
    commercialName: '',
    equipmentTypeId: '',
    zipCode: '',
    city: '',
    state: '',
    colonia: '',
    rfc: '',
    quoteCategory: '',
    quoteCategoryId: '',
    personType: ''
  };
};

export default makeInitialState;
